export const InboundTypes = [
    {
        value: '0',
        key: 'Sms',
        name: 'appBar.sms.title',
        disabled: false,
        icon: null,
        isNewFeature: false
    },
    {
        value: '1',
        key: 'Whatsapp',
        name: 'master.whatsapp',
        disabled: false,
        icon: null,
        isNewFeature: false
    }
]